import {useState} from 'react';
import {
  ProductPageIconsForFreeShippingMoneyBackAndWarranty
} from '@components/product/global/ProductPageIconsForFreeShippingMoneyBackAndWarranty';
import {
  skuIsLoadedOrUnloadedVehicleSpecificEnclosure
} from '@helpers/products/vehicle-specific.mjs';
import {AddToCartMobile} from './mobile/AddToCartMobile';
import {
  MainImageAndGallerySliderMobile
} from '@components/product/mobile/MainImageAndGallerySliderMobile';
import {ProductVariantSelector} from '@components/product/global/ProductVariantSelector';
import {BuildProductTabs} from '@components/product/global/BuildProductTabs';
import {Breadcrumbs} from '@components/product/global/Breadcrumbs';
import {CustomerReviewsFromDb} from '@components/product/reviews/reviews-with-images';
import {PricesMobile} from '@components/product/mobile/PricingMobile';
import {FrequentlyBoughtTogether} from './global/FrequentlyBoughtTogether';
import {ReviewStarsLinkWrapper} from '@components/widgets/Common';
import {ReviewStarsFromDb} from '@components/product/reviews/review-stars-from-db';
import {useProductProvider} from '@components/product/ProductProvider';
import {YoutubeEmbed} from '@components/media/YoutubeEmbed';
import {
  ModalGalleryV3_YARLB
} from '@components/product/desktop/ModalGalleryYetAnotherReactLightBox';
import {LowStockSalesPitch} from '@components/product/global/LowStockDisplay';

export const ProductDetailsMobile = ({reviewsFromDb}) => {
  // console.log('[ProductDetailsMobile] reviewsFromDb:', reviewsFromDb);
  const [currentImage, setCurrentImage] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const {
    sku,
    variants,
    selectedVariant,
    breadcrumbs,
    vehicleFitment,
    frequentlyBoughtTogetherAssociations,
    currentVariantReviewData
  } = useProductProvider();
  // console.log('[ProductDetailsMobile] selectedVariant:', selectedVariant);

  const breadcrumbSku = breadcrumbs?.breadCrumbLevel3Title;
  let categoryLink = breadcrumbs?.breadCrumbLevel1;
  let categoryName = breadcrumbs?.breadCrumbLevel1Title;
  let collectionLink = breadcrumbs?.breadCrumbLevel2;
  let collectionName = breadcrumbs?.breadCrumbLevel2Title;

  const hasVariants = variants?.length;
  const skuList = hasVariants ? variants?.map((variant) => variant?.sku) : [selectedVariant?.sku];

  const productImages = selectedVariant?.images;
  // console.log('[ProductDetailsMobile] productImages:', productImages);

  const siteName = selectedVariant?.siteName;
  const productVideo = selectedVariant?.video?.url;

  const skuIsVehicleSpecific = skuIsLoadedOrUnloadedVehicleSpecificEnclosure(sku);
  if (skuIsVehicleSpecific) {
    const vehicleMake = vehicleFitment?.vehicleMake;
    categoryLink = 'vehicle-specific-subwoofer-enclosures';
    categoryName = 'Vehicle Specific Enclosures';
    collectionLink = `/collections/vehicle-specific-subwoofer-enclosures?vehicle_make=${vehicleMake}`;
    collectionName = vehicleMake;
  }

  const closeLightbox = () => {
    setCurrentImage(0);
    setIsOpen(false);
  };

  const avgScore = currentVariantReviewData?.avgScore;
  const reviewCount = currentVariantReviewData?.count;

  return <div className="mt-1">
    <div className="px-2">
      <Breadcrumbs
        aria-label="Breadcrumb"
        sku={breadcrumbSku}
        categoryLink={categoryLink}
        categoryName={categoryName}
        collectionLink={collectionLink}
        collectionName={collectionName}
        excludeCategoryLevel={true}
      />
      {siteName && (
        <h1 className="product-subtitle" style={{fontSize: '16px', fontWeight: '500'}}>
          {siteName}
        </h1>
      )}
    </div>

    <div className="mt-1 mb-1">
      <MainImageAndGallerySliderMobile
        selectedVariant={selectedVariant}
        sku={sku}
        productImages={productImages}
        setIsOpen={setIsOpen}
      />

      <ModalGalleryV3_YARLB
        sku={sku}
        images={productImages}
        viewerIsOpen={isOpen}
        closeLightbox={closeLightbox}
        photoIndex={currentImage}
        setPhotoIndex={setCurrentImage}
      />
    </div>

    <div>
      <div className="px-2">
        <ReviewStarsLinkWrapper product={reviewsFromDb}>
          <ReviewStarsFromDb avgScore={avgScore} count={reviewCount} />
        </ReviewStarsLinkWrapper>

        <PricesMobile product={selectedVariant} />

        <ProductVariantSelector product={selectedVariant} />

        <LowStockSalesPitch selectedVariant={selectedVariant} />

        <AddToCartMobile product={selectedVariant} />
      </div>
    </div>

    <BuildProductTabs selectedVariant={selectedVariant} isMobile={true} />

    {selectedVariant?.price > 25 && (
      <div className="mt-4 mb-3">
        <ProductPageIconsForFreeShippingMoneyBackAndWarranty />
      </div>
    )}

    {frequentlyBoughtTogetherAssociations && (
      <div className={'mt-4 mb-2'}>
        <FrequentlyBoughtTogether products={frequentlyBoughtTogetherAssociations} />
      </div>
    )}

    {productVideo && (
      <div className="bg-gray-100 flex justify-center py-4">
        <div className="w-full px-2 md:w-3/4 lg:w-1/2">
          <YoutubeEmbed url={productVideo} />
        </div>
      </div>
    )}

    <a name="product-reviews" id="product-reviews" />
    <div className="border-t border-t-neutral-200">
      <CustomerReviewsFromDb
        sku={sku}
        skuList={skuList}
        selectedVariant={selectedVariant}
        currentVariantReviewData={currentVariantReviewData}
        isMobile={true}
      />
    </div>
  </div>;
};
